import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@core/interfaces';

@Pipe({
  name: 'formatAddress'
})
export class FormatAddressPipe implements PipeTransform {
  transform(address: Address): string {
    const parts = [];
    const streetAndNumber = [];
    address.streetName && streetAndNumber.push(address.streetName);
    address.number && streetAndNumber.push(address.number);

    const formattedStreetAndNumber = streetAndNumber.join(', ');
    parts.push(formattedStreetAndNumber);

    address.neighborhood && parts.push(address.neighborhood);
    address.city && parts.push(address.city);
    address.postalCode && parts.push(address.postalCode);
    return parts.join(' - ');
  }
}